// Basic
import { useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
// Store & actions
import actionsSims from '@/app/modules/sims/api/actionsSims';
// Components
import Page from '@/common-utils/components/structure/page/Page';
import Entity from '@/common-utils/components/renders/entity/Entity';
import Icon from '@/common-utils/components/renders/icon/Icon';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/common-utils/components/ui/accordion';
import SimDetails from '@/app/modules/sims/components/details/SimDetails';
// Common
import RouteUrls from '../../enums/RouteUrls';
import ICONS from '@/common-utils/enums/icons';
import simCardFields from '@/app/modules/sims/fields/simCardFields';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import SIM_CARDS_TABS from '../../enums/tabs/SimCardsTabs';
import getIccidWithoutPrefix from '@/common-utils/functions/getIccidWithoutPrefix';

/**
 * @returns {JSX} SimCardDetails
 */
function SimCardDetails() {
    // URL Params
    const { simCardId } = useParams();

    // API Calls
    const { data: simCard, isFetching, isError, refetch } = actionsSims.getSimCard(simCardId, true);

    // State
    const [openSimDetails, setOpenSimDetails] = useState(true);

    // Constants
    const i18nData = { iccid: simCard ? getIccidWithoutPrefix(getObjectAttributeFromStringKey(simCard, generateNestedFieldAccessor(simCardFields.SIM_CARD.ICCID))) : {} };

    // Redirection
    if (isError) {
        return <Navigate to={RouteUrls.SIM_CARDS.url} />;
    }

    return (
        <Page>
            <Page.Header
                route={RouteUrls.SIM_CARDS_DETAILS}
                i18nData={i18nData}
                prevView={SIM_CARDS_TABS.SIM_CARDS.name}
                isLoading={isFetching}
                routeBase={RouteUrls.SIM_CARDS}
            />
            {isFetching ?
                <Spinner className='full-screen-loading' /> :
                <Page.Body>
                    <Accordion type='multiple' defaultValue={['item-1']}>
                        <AccordionItem
                            className='rounded-md'
                            value='item-1'
                        >
                            <AccordionTrigger
                                className='opacity-[.8]'
                                open={openSimDetails}
                                onClick={() => setOpenSimDetails(!openSimDetails)}
                            >
                                <div className='flex items-center gap-2'>
                                    <Icon icon={ICONS.GPRS} />
                                    <Entity entity={'page.sim_card.title'} />
                                </div>
                            </AccordionTrigger>
                            <AccordionContent>
                                {
                                    simCard &&
                                    <SimDetails simCard={simCard} refetch={refetch} />
                                }
                            </AccordionContent>
                        </AccordionItem>
                    </Accordion>
                </Page.Body>
            }
        </Page>
    );
}

export default SimCardDetails;